import { useState } from 'react';

/**
 * Numero di telefono cliccabile.
 * - Su touch (mobile/tablet): href tel: → fa partire la chiamata.
 * - Su desktop (pointer fine): preventDefault e copia il numero negli appunti,
 *   mostrando un breve feedback "Copiato!".
 *
 * La href tel: rimane sempre, così il click-destro/long-press funziona ovunque
 * e i lettori di schermo riconoscono il link.
 */
export function PhoneLink({ phone, prefix = '📞 ' }: { phone: string; prefix?: string }) {
  const [copied, setCopied] = useState(false);

  // Pulizia minima per la href tel:: rimuoviamo solo gli spazi superflui,
  // mantenendo +, cifre, parentesi, trattini (validi nello schema tel:).
  const href = `tel:${phone.replace(/\s+/g, '')}`;

  function onClick(e: React.MouseEvent<HTMLAnchorElement>) {
    const isTouch =
      typeof window !== 'undefined' &&
      window.matchMedia &&
      window.matchMedia('(pointer: coarse)').matches;
    if (isTouch) return; // lascia partire la chiamata
    e.preventDefault();
    void (async () => {
      try {
        await navigator.clipboard.writeText(phone);
        setCopied(true);
        setTimeout(() => setCopied(false), 1600);
      } catch {
        // Niente clipboard API (es. http o browser vecchio): seleziona il testo
        // tramite Range come fallback minimale.
        const range = document.createRange();
        range.selectNodeContents(e.currentTarget);
        const sel = window.getSelection();
        sel?.removeAllRanges();
        sel?.addRange(range);
      }
    })();
  }

  return (
    <a
      href={href}
      className="phone-link"
      onClick={onClick}
      title="Tap per chiamare (mobile) · click per copiare (desktop)"
    >
      {prefix}
      {phone}
      {copied && <span className="phone-link-feedback">Copiato!</span>}
    </a>
  );
}
